import { SingleKeyObject } from '@mangovoice/types'

export const getName = <T extends PropertyKey>(object: SingleKeyObject<T>) => {
  return Object.keys(object)[0]
}

/**
 * Overrides the properties of the source object with the properties of the target object,
 * but keeping the reference to the source object the same as it was
 * @param sourceObject The object to be overwritten
 * @param targetObject The object to use to override the source object
 * @returns The updated source object. If the source object was falsy, the target object is returned instead
 */
export const shallowOverwrite = <T extends object>(
  sourceObject: T,
  targetObject: T,
) => {
  if (!sourceObject && targetObject) {
    return targetObject
  }
  const sourceObjectKeys = Object.keys(sourceObject)
  const targetObjectKeys = Object.keys(targetObject)

  //remove source object keys that do not exist in the target
  for (const key of sourceObjectKeys) {
    const typedKey = key as keyof T
    if (!targetObjectKeys.includes(key)) {
      delete sourceObject[typedKey]
    }
  }

  for (const key in targetObject) {
    sourceObject[key] = targetObject[key]
  }

  return sourceObject
}
